import { useQuery } from '@tanstack/react-query';
import { getDateByDateKey } from '../../utils/apiUtils';
import { useInView } from 'react-intersection-observer'

const HrpDate = ({ dateKey }) => {

    const { ref, inView } = useInView({
        triggerOnce: true, // Optional: Only trigger the query the first time it enters view
        threshold: 0.1,    // Optional: Triggers when 10% of the element is visible
    })

    const { data, isLoading, error } = useQuery({
        queryKey: ['hrpdate', dateKey],
        queryFn: async () => {
            const result = await getDateByDateKey(dateKey);
            return result;
        },
        select: (data) => data[0],
        staleTime: Infinity,
        enabled: !!(dateKey && dateKey !== 'null') && inView,
    });
    return (
        <>
            {dateKey == '-9223372036854776000' ? '01/01/1800' : dateKey == '9223372036854776000' ? '01/01/3000' : data && data.dateName2}
            <br ref={ref} />
            {isLoading && 'Loading...'}
            {error && <p className='danger'>{error.messsage}</p>}
        </>
    );
};

export default HrpDate;
